// extracted by mini-css-extract-plugin
export default {"button":"Button_button__iEiBG","solid":"Button_solid__p8rTi","small":"Button_small__M5plk"};